import moment from 'moment';
import { message } from 'antd';
import { METRIC_NEWAPP_VERSION } from '@utils/constants';

export const deviceName = METRIC_NEWAPP_VERSION;
export const appVersion = 'appVersion';
export const spiStreams = 'SpiStreams';
export const streamingPerformanceIndex = 'StreamingPerformanceIndex';

export const formatInterval = (value: any) => {
  try {
    if (value && value.length > 0) {
      const formatMins =  moment(value).format('mm');
      return moment(value).add(formatMins, 'minutes').set('minute',0).set('second',0).format();
    }
  } catch (err) {
    const errorMsg = 'Unknown error!';
    message.error(errorMsg);
  }
  return true;
};

export const formatDate = (value: any) => {
  try {
    if (value && value.length > 0) {
      return moment(value).format('LL');
    }
  } catch (err) {
    const errorMsg = 'Unknown error!';
    message.error(errorMsg);
  }
  return true;
};
